/*  */

setup();
document.addEventListener("remount:login", remount);

function remount() {
  // Logical groupings of error states, update methods, and dom element references per input field
  var Email = {
    elem:document.querySelector("#input-email"),
    errors:false,
    update:function(andRender){
      Email.errors = ( Email.elem.value.length>4 && Email.elem.value.indexOf("@")!=-1 && Email.elem.value.indexOf(".")!=-1 ) ? false : ["Invalid email address"];
      if(andRender){Email.render();}
      return Email.errors;
    },
    render:function(){
      updateField( Email.errors, Email.elem.parentNode );
    }
  };

  var Password = {
    elem:document.querySelector("#input-password"),
    errors:false,
    update:function(andRender){
      Password.errors = (Password.elem.value.length > 0) ? false : ["Invalid password"];
      if(andRender){Password.render();}
      return Password.errors;
    },
    render:function(){
      updateField( Password.errors, Password.elem.parentNode );
    }
  };

  // when resuming interation with a field with errors, first hide any errors so if there are errors again after editing, it will be obvious that the errors are being re-displayed
  Email.elem.addEventListener("focus", function(){ Email.errors = false; Email.render(); });
  Password.elem.addEventListener("focus", function(){ Password.errors = false; Password.render(); });


  var emailForm = document.querySelector("#email_login");
  emailForm.addEventListener("submit", function(e) {
    e.preventDefault();
    var valid = true;
    if (Email.update(true)) {
      valid = false;
    }
    
    if (Password.update(true)) {
      valid = false;
    }
    
    if (valid) {
      var activeForm = document.querySelector(".js-form_active");
      var processingForm = document.querySelector(".js-form_processing");
      addClass(activeForm, 'hide-from-view');
      removeClass(processingForm, 'hide-from-view');
      return emailForm.submit();
    }

    return false;

  });
}

function setup() {
  remount();
}

/*
Functions for updating display (assigning classes, style attributes, and manipulation of data attributes happen here).
These are pure functions that do not reference outside objects.
*/

// update field to show/hide errors
function updateField(inError, inElem){

  Array.prototype.slice.call(inElem.querySelectorAll(".login__tiptext--warn")).forEach(function(e){inElem.removeChild(e);});

  if(inError && inError.length){
    inError.forEach(function(){
      var span = document.createElement("span");
      span.innerHTML = inError;
      span.className = "login__tiptext login__tiptext--warn";
      inElem.appendChild(span);
    });
    inElem.classList.add("field--warn");
  } else {
    inElem.classList.remove("field--warn");
  }
}

// Helper functions for manipulating Class names
function hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp('\\b'+ className+'\\b').test(el.className);
}

function addClass(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!hasClass(el, className)) el.className += ' ' + className;
}

function removeClass(el, className) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp('\\b'+ className+'\\b', 'g'), '');
}
